import React, { Component } from 'react';
import Widget from '../common/Widget';
// import {ResourceLinks} from './config';
import { List, ListItem, Tooltip } from '@mui/material';
import PortalTooltip from '../common/PortalTooltip';
import PortalLink from '../common/PortalLink';
import { Link as RouterLink } from 'react-router-dom';

class Resources extends Component {
  state = {
    isExpand: true,
    //TODO: enable in v1.1
    // menu:[
    //     {id: "Resources_hide", title: "Hide"},
    // ]
  };

  toggleExpand = () => {
    this.setState({ isExpand: !this.state.isExpand });
  };

  render() {
    return (
      <>
        <Widget
          data={{
            id: this.props.widget.id,
            title: this.props.title,
            isTitleStylized: this.props.isTitleStylized,
            isExpand: this.props.widget.isExpand,
            isRequired: this.props.widget.isRequired,
          }}
          {...this.props}
          className="myOdu__resources"
          hasScrollY
        >
          <div className="wrapper" id={this.props.widget.id + '__resources__listWrapper'}>
            <List sx={{ pt: 0 }} dense={true} id={this.props.widget.id + '__resources__list'}>
              {this.props.resourceLinks.map((resource) => (
                <ListItem
                  id={this.props.widget.id + '__resources__listItem_' + resource.id}
                  sx={{ pl: 1 }}
                  key={this.props.widget.id + '__resources__listItem_' + resource.id}
                  divider
                >
                  <PortalLink
                    id={this.props.widget.id + '__resources__link_' + resource.id}
                    variant="small"
                    underline={'hover'}
                    className="noIcon"
                    ariaLabel={resource?.ariaLabel}
                    {...(resource.specialAccess
                      ? {
                          component: RouterLink,
                          to: '/specialAccess',
                          state: {
                            message: resource.specialAccess.message,
                            link: resource.link,
                            title: resource.title,
                          },
                        }
                      : {
                          href: resource.link,
                          target: '_blank',
                        })}
                  >
                    {resource.title}
                  </PortalLink>
                </ListItem>
              ))}
            </List>
          </div>
        </Widget>
      </>
    );
  }
}

export default Resources;
